const CameraComponentStyle = theme => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500]
  }
});

export default CameraComponentStyle;
